// extracted by mini-css-extract-plugin
export var copyIcon = "_xj-2";
export var discountCard = "_xj-0";
export var discountCode = "_xj-3";
export var discountContent = "_xj-1";
export var loadingCard = "_xj-4";